import * as React from "react";

const QtyMinusIcon: React.FC = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1688 7.07436H1.03126C0.78376 7.07436 0.556885 6.86811 0.556885 6.59999C0.556885 6.35249 0.763135 6.12561 1.03126 6.12561H12.1688C12.4163 6.12561 12.6431 6.33186 12.6431 6.59999C12.6431 6.84749 12.4163 7.07436 12.1688 7.07436Z" fill="#414243"/>
        </svg>
    );
};

export default React.memo(QtyMinusIcon);